import React from "react";
import { UiBlueBox } from "../../../../../_uiComponents/common/UiBlueBox";
import { UiCol, UiSingleRow } from "../../../../components/grid-container/GridContainer";
import TropyStar from '../../../../../../styles/img/tropystar.png';

export const CourseCompletedInfo = () => {
    return (
        <>
            <div className="sb-course-completed-info">
                <UiSingleRow >
                    <UiCol lg="3" className="sb-course-completed-info__icon-card" >
                        <div>
                            <div className="sb-ic-card-flx">
                                <img src={TropyStar} />
                                <h3>Badge Awarded!</h3>
                            </div>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </p>
                        </div>

                    </UiCol>
                    <UiCol lg="9" className="sb-course-completed-info__content-card" >
                        <h2>Course Completed</h2>
                        <p className="text-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                            tempor incididunt ut ero labore et dolore magna aliqua.  </p>

                        <UiSingleRow>
                            <UiCol md="3">
                                <p><strong>Date Started:</strong></p>
                                <h5>10/01/23</h5>
                            </UiCol>

                            <UiCol md="3">
                                <p> <strong>Time to Complete:</strong></p>
                                <h5>12 Days</h5>
                            </UiCol>

                            <UiCol md="3">
                                <p> <strong>Completed:</strong></p>
                                <h5>22/01/23</h5>
                            </UiCol>

                            <UiCol md="3">
                                <p><strong>Average Score:</strong></p>
                                <h5>77%</h5>
                            </UiCol>

                            <UiCol md="3">
                                <p><strong>Avg Answer Speed:</strong></p>
                                <h5>5 Secs</h5>
                            </UiCol>

                            <UiCol md="3">
                                <p> <strong> Average Completion Time:</strong></p>
                                <h5>1.5 Days</h5>
                            </UiCol>


                        </UiSingleRow>
                    </UiCol>
                </UiSingleRow>
            </div>

        </>
    )
}